<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <mappedClass-table
            v-if="mappedClasses && mappedClasses.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:mappedClasses="mappedClasses"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-mapped-classs="getAllMappedClasses"
             >

            </mappedClass-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import MappedClassTable from "@/components/MappedClassTable";
import MappedClassService from "../services/MappedClassService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    MappedClassTable,
  },
  data() {
    return {
      mappedClasses: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllMappedClasses(sortBy='mappedClassId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await MappedClassService.getAllMappedClasses(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.mappedClasses.length) {
					this.mappedClasses = response.data.mappedClasses;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching mappedClasses:", error);
        }
        
      } catch (error) {
        console.error("Error fetching mappedClass details:", error);
      }
    },
  },
  mounted() {
    this.getAllMappedClasses();
  },
  created() {
    this.$root.$on('searchQueryForMappedClassesChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllMappedClasses();
    })
  }
};
</script>
<style></style>
